<template>
  <v-dialog v-model="isActive" persistent scrollable max-width="375">
    <v-card max-width="375" class="mx-auto">
      <v-img
        dark
        height="300px"
        :src="userData.avatar"
        gradient="to top, rgba(0,0,0,.0) 65%, rgba(0,0,0,.5)100%"
      >
        <v-card-title>
          <v-btn dark icon class="mr-4" @click="closeDialog()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <!-- <v-btn dark icon class="mr-4">
              <v-icon>mdi-pencil</v-icon>
            </v-btn> -->

          <!-- <v-btn dark icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn> -->
          <div class="text-h6">
            {{ userData.name }}
          </div>
        </v-card-title>
      </v-img>

      <v-list two-line>
        <v-list-item>
          <v-list-item-icon>
            <v-icon color="indigo">
              mdi-phone
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ userData.whatsapp }}</v-list-item-title>
            <v-list-item-subtitle>WhatsApp</v-list-item-subtitle>
          </v-list-item-content>

          <!-- <v-list-item-icon>
            <v-icon>mdi-message-text</v-icon>
          </v-list-item-icon> -->
        </v-list-item>

        <v-list-item>
          <v-list-item-action></v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>{{ userData.phone1 }}</v-list-item-title>
            <v-list-item-subtitle>Teléfono 1</v-list-item-subtitle>
          </v-list-item-content>

          <!-- <v-list-item-icon>
            <v-icon>mdi-message-text</v-icon>
          </v-list-item-icon> -->
        </v-list-item>
        <!-- 
        <v-divider inset></v-divider>

        <v-list-item>
          <v-list-item-icon>
            <v-icon color="indigo">
              mdi-email
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>aliconnors@example.com</v-list-item-title>
            <v-list-item-subtitle>Personal</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item> -->

        <!-- <v-divider inset></v-divider> -->

        <!-- <v-list-item>
          <v-list-item-icon>
            <v-icon color="indigo">
              mdi-map-marker
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>1400 Main Street</v-list-item-title>
            <v-list-item-subtitle>Orlando, FL 79938</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item> -->
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "contactDetailsDialog",

  props: {
    isActive: Boolean,
    userData: Object,
  },

  methods: {
    closeDialog() {
      this.$emit("dialog:close");
    },
  },
};
</script>
